var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonatiWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "163px",
    height: "26px",
    viewBox: "0 0 163 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Donati_Logo_White_Black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.06 0.314 182.582 0.314 182.582 40 0.06 40"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Donati---Home",
    transform: "translate(-265.000000, -2602.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(180.000000, 2555.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Donati_Logo_White_Black",
    transform: "translate(81.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.436,28.293 C70.444,28.293 72.118,26.385 72.118,23.841 C72.118,21.196 70.645,19.287 68.436,19.287 C66.092,19.287 64.785,21.295 64.785,23.607 C64.785,26.385 66.158,28.293 68.436,28.293 Z M78.145,32.512 L72.588,32.512 L72.588,29.398 L72.52,29.398 C71.75,31.34 69.306,32.914 66.527,32.914 C61.338,32.914 58.559,28.629 58.559,23.472 C58.559,19.186 61.203,14.666 66.024,14.666 C68.436,14.666 70.478,15.302 72.018,17.311 L72.085,17.311 L72.085,7.401 L78.145,7.401 L78.145,32.512 Z",
    id: "Fill-5",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.762,23.807 C94.762,21.196 93.623,18.884 90.843,18.884 C88.064,18.884 86.926,21.196 86.926,23.807 C86.926,26.385 88.064,28.695 90.843,28.695 C93.623,28.695 94.762,26.385 94.762,23.807 Z M80.699,23.807 C80.699,18.014 85.084,14.666 90.843,14.666 C96.603,14.666 100.988,18.014 100.988,23.807 C100.988,29.566 96.603,32.914 90.843,32.914 C85.084,32.914 80.699,29.566 80.699,23.807 Z",
    id: "Fill-6",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.606,15.069 L109.098,15.069 L109.098,18.283 L109.164,18.283 C110.37,15.771 112.781,14.666 115.525,14.666 C120.28,14.666 122.189,18.014 122.189,21.631 L122.189,32.512 L116.162,32.512 L116.162,24.075 C116.162,20.793 115.023,19.688 113.382,19.688 C110.905,19.688 109.634,21.396 109.634,25.146 L109.634,32.512 L103.606,32.512 L103.606,15.069",
    id: "Fill-7",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.711,28.896 C134.987,28.896 136.427,26.82 136.427,24.777 C135.657,24.744 134.787,24.678 133.882,24.678 C131.84,24.678 130.232,25.312 130.232,26.988 C130.232,28.193 131.304,28.896 132.711,28.896 Z M136.862,32.512 C136.829,31.574 136.729,30.67 136.729,29.768 L136.661,29.768 C135.289,31.943 133.614,32.914 131.138,32.914 C127.688,32.914 124.607,31.205 124.607,27.424 C124.607,22.099 130.4,21.463 133.614,21.463 C134.586,21.463 135.657,21.564 136.427,21.698 C136.394,19.32 134.619,18.684 132.443,18.684 C130.5,18.684 128.56,19.053 126.885,19.99 L126.783,15.905 C128.927,15.035 131.17,14.666 133.749,14.666 C138.202,14.666 142.052,16.575 142.052,21.899 L142.052,28.395 C142.052,29.768 142.119,31.139 142.387,32.512 L136.862,32.512 Z",
    id: "Fill-8",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.751,15.069 L147.301,15.069 L147.301,11.15 L153.227,9.31 L153.227,15.069 L157.445,15.069 L157.445,19.287 L153.227,19.287 L153.227,25.715 C153.227,27.824 153.729,28.896 155.638,28.896 C156.241,28.896 156.876,28.762 157.479,28.662 L157.68,32.578 C156.542,32.713 155.403,32.914 153.896,32.914 C148.506,32.914 147.2,30.535 147.2,26.385 L147.2,19.287 L143.751,19.287 L143.751,15.069",
    id: "Fill-9",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.444,32.512 L166.47,32.512 L166.47,15.069 L160.444,15.069 L160.444,32.512 Z M160.444,12.222 L166.47,12.222 L166.47,7.803 L160.444,7.803 L160.444,12.222 Z",
    id: "Fill-10",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-11",
    fill: "#FFFFFE",
    points: "16.42 32.914 25.905 7.54 35.434 32.914 16.42 32.914"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-12",
    fill: "#FFFFFE",
    points: "23.265 7.401 13.78 32.777 4.252 7.401 23.265 7.401"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonatiWhite);
export default __webpack_public_path__ + "static/media/donati-white.6805aba2931501e01cd7ee026b1f10dc.svg";
export { ForwardRef as ReactComponent };